<form autocomplete="off" #crpLogIn name="crpLogIn" method="POST">
  <input type="hidden" #crpGroup name="target-group-id" />
</form>
<cigna-caheader-impersonator
  [isImpersonationUser]="isImpersonatorFlag"
  [isImpersonatorSignin]="isImpersonatorFlag"
  [menuItemsWithSubMenu]="menuItemsWithSubMenu$ | async"
  [impFirstName]="firstName$ | async"
  [impLastName]="lastName$ | async"
  [operatorId]="operatorId"
  [firstName]="firstName$ | async"
  [lastName]="lastName$ | async"
  [internalFirstName]="internalFirstName"
  [internalLastName]="internalLastName"
  [currentUrlPath]="currentUrlPath"
  (secureMessage)="navigateSecureMessage($event)"
  [attr.data-test-id]="'hdTopHeaderComponent'"
  [menuItemsWithSubMenu]="menuItemsWithSubMenu$ | async"
  [navigationEntitlements]="navigationEntitlements$ | async"
  [isSideBarToggleFlag]="sideBarToggleFlag"
  [isScreenSmall]="isScreenSmall"
  [attr.data-test-id]="'snPrimaryComponentContainer'"
  [resizeSideNavToggle]="resizeSideNavToggle$ | async"
  (appRedirect)="appRedirect($event)"
></cigna-caheader-impersonator>
<div
  *ngIf="!isImpersonatorFlag"
  fxLayout="row"
  class="header"
  data-test-id="hdContainer"
>
  <div fxFlex="20%" fxLayoutAlign="start center" data-test-id="hdLogoContainer">
    <cigna-header-logo
      [enableToggleSidNav]="true"
      [attr.data-test-id]="'hdLogoConmponent'"
      [resizeSideNavToggle]="resizeSideNavToggle$ | async"
      (resizeSideNavToggleEmit)="resizeSideNavToggle($event)"
    ></cigna-header-logo>
  </div>
  <div fxFlex="80%" fxLayout="column" data-test-id="hdTopWrapper">
    <cigna-caheader-secure
      (toggleSideMenu)="sideBarToggleFlag = $event"
      [firstName]="firstName$ | async"
      [lastName]="lastName$ | async"
      [internalFirstName]="internalFirstName"
      [internalLastName]="internalLastName"
      [loading]="loading$ | async"
      [navigation]="navigation$ | async"
      (toggleTheme)="toggleTheme()"
      (toggleSidenav)="sidenav.toggle()"
      (toggleDir)="toggleDir()"
      (logout)="processLogout()"
      (secureMessage)="navigateSecureMessage($event)"
      [attr.data-test-id]="'hdTopHeaderComponent'"
      [menuItemsWithSubMenu]="menuItemsWithSubMenu$ | async"
      [navigationEntitlements]="navigationEntitlements$ | async"
      [isSideBarToggleFlag]="sideBarToggleFlag"
      [isScreenSmall]="isScreenSmall"
      [attr.data-test-id]="'snPrimaryComponentContainer'"
      [resizeSideNavToggle]="resizeSideNavToggle$ | async"
      (appRedirect)="appRedirect($event)"
      [isImpersonatorFlag]="isImpersonatorFlag"
      (windowOpen)="navigateSecureMessage($event)"
      [currentUrlPath]="currentUrlPath"
    ></cigna-caheader-secure>
  </div>
</div>

<mat-sidenav-container
  class="app-sidenav-container"
  [class.dark-theme]="isDarkTheme"
  [autosize]="true"
  [dir]="dir"
  [attr.data-test-id]="'snContainer'"
>
  <mat-sidenav
    *ngIf="!enableFullScreen(currentUrlPath)"
    #sidenav
    class="app-sidenav"
    [opened]="!isScreenSmall"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [attr.data-test-id]="'snContainerComponent'"
    [ngClass]="{
      resizeSideNavToggleWrap: resizeSideNavToggle$ | async,
      'brportal-sidenav': true
    }"
  >
    <cigna-caprimary-nav
      *ngIf="!canHideSideNav"
      [menuItemsWithSubMenu]="menuItemsWithSubMenu$ | async"
      [navigationEntitlements]="navigationEntitlements$ | async"
      [sideBarToggleFlag]="sideBarToggleFlag"
      [isScreenSmall]="isScreenSmall"
      [isImpersonatorFlag]="isImpersonatorFlag"
      [attr.data-test-id]="'snPrimaryComponentContainer'"
      [resizeSideNavToggle]="resizeSideNavToggle$ | async"
      (openExternalPage)="openExternalLink($event)"
      (appRedirect)="appRedirect($event)"
      (windowOpen)="navigateSecureMessage($event)"
    ></cigna-caprimary-nav>
  </mat-sidenav>

  <div
    [ngClass]="{
      'app-sidenav-content': !enableFullScreen(currentUrlPath),
      'fs-sideNav': enableFullScreen(currentUrlPath)
    }"
    data-test-id="cnAppContainer"
    fxLayout="column"
    fxLayoutAlign="space-between none"
  >
    <div
      [ngClass]="{
        wrapper:
          !enableFullScreen(currentUrlPath) &&
          !isSolutionsInsights(currentUrlPath),
        'fs-wrapper': enableFullScreen(currentUrlPath),
        'solutions-insights-wrapper': isSolutionsInsights(currentUrlPath)
      }"
      data-test-id="cnAppWrapper"
    >
      <router-outlet></router-outlet>
    </div>
    <ng-container>
      <div [ngClass]="isFundingSolution(currentUrlPath) ? 'fs-footer' : ''">
        <cigna-cafooter-secure
          [isDivestEnabled]="isDivestEnabled"
        ></cigna-cafooter-secure>
      </div>
    </ng-container>
  </div>
</mat-sidenav-container>
